export default function getBindedLocalSelectors(local, storePath) {
  const local$ = {};
  Object.keys(local).forEach((key) => {
    local$[key] = (state, props) => local[key](state, props, storePath);
  });

  return local$;
}



// WEBPACK FOOTER //
// ./src/utils/getBindedLocalSelectors.js